export const encodeStateParam = state => {
  // takes a pojo and returns a base64 encoded ascii string
  const serializedState = JSON.stringify(state);

  let encodedState;
  try {
    encodedState = btoa(serializedState);
  } catch(error){
    console.log(error)
  }

  return encodedState;
};

export const decodeStateParam = encodedState => {
  //takes a base64-encoded binary string and returns a pojo
  let decodedState;
  try {
    decodedState = atob(encodedState);
  } catch(error){
    console.log(error)
  }

  return JSON.parse(decodedState);
};
